export function formatDate(date) {
    return new Date(date).toLocaleDateString('en-us', {
        timeZone: 'UTC',
        weekday: 'long',
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    })
}

export function formatMoney (amount) {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    }).format(amount)
}

export const combineReducers = (reducers) => {
    return (state = {}, action) => {
        return Object.keys(reducers).reduce((nextState, key) => {
            nextState[key] = reducers[key](state[key], action);
            return nextState;
        }, {});
    }
}
export const dateFormatter = (date) => {
    const joiner = (date, opts) => {
        const format = (opt) => {
            let formatter = new Intl.DateTimeFormat('en', opt)
            return formatter.format(date)
        }
        return opts.map(format).join('-')
    }
    const options = [{year: "numeric"}, {month: "2-digit"}, {day: "2-digit"}]
    return joiner(date, options)
}


export const sortOrderMap = (m, compFn) =>
    Object.entries(m)
        .sort(compFn)
        .reduce((acc, [id, player]) => ({
            ...acc,
            [id]: player
        }), {});
 
